import React from "react";

const faq8 = () =>{
  return(
    <>
      <p>
        Täckningsbidraget uttryckt i procent (%) av 
        intäkten. Visar vilken del av varje intjänad 
        krona som finns kvar – efter avdrag för 
        rörliga kostnader – att täcka firmans övriga 
        kostnader.
      </p>
      <p>
        Se Flik: <u>Fält & Rubriker/Täckningsgrad</u>
      </p>
     
    
    </>
  );
}
export default faq8;